import Elora1 from '../Elora/Elora (1).webp'
import Elora2 from '../Elora/Elora (2).webp'
import Elora3 from '../Elora/Elora (3).webp'
import Elora4 from '../Elora/Elora (4).webp'
import Elora5 from '../Elora/Elora (5).webp'
import Elora6 from '../Elora/Elora (6).webp'
import Elora7 from '../Elora/Elora (7).webp'
import Elora8 from '../Elora/Elora (8).webp'
import Elora9 from '../Elora/Elora (9).webp'
import Elora10 from '../Elora/Elora (10).webp'


const Eloraimages =[
Elora1,Elora2,Elora3,Elora4,Elora5,Elora6,Elora7,Elora8,Elora9,Elora10
]

export default Eloraimages;